import React, { useRef, useEffect, useState } from "react";
import ReactGA from "react-ga4";
import emailjs from "@emailjs/browser";
import contactConfig from "../confi";
import { useNavigate } from "react-router-dom";
import "./sub.css";
import Helmet from "react-helmet";
import JobMember from "../Component/sub-component/JobMember";
import CityLocation from "../Component/sub-component/CityLocation";
import LatestThreeBlog from "./LatestThreeBlog";
import Ahmedabad from "../images/Ahmedabad.jpeg";
import vadodra from "../images/vadodara.jpeg";
import surat from "../images/Surat.jpeg";
import jaipur from "../images/Jaipur.jpeg";
import vapi from "../images/Vapi.jpeg";
import rajkot from "../images/Rajkot.jpeg";
import mehsana from "../images/Mehsana.jpeg";
import gandhinagar from "../images/gandhinager.jpeg";
import bhavnagar from "../images/Bhavnager.jpeg";
// import dehi from '../images/Delhi.jpeg';
import mumbai from "../images/Mumbai.jpeg";
import bangalore from "../images/Bangalore.jpeg";

//service role images
import driver from "../images/driver.jpeg";
import service from "../images/service.jpeg";

import ElderlyCare from "../images/ederly care.jpeg";
import patientcare from "../images/patientcare.jpeg";
import babysitting from "../images/babysitting.jpeg";
import officeboy from "../images/officeboy.jpeg";
import homemaid from "../images/homemaidservice.jpeg";

//job member
import maids from "../images/maid indian.jpg";
import babysitter from "../images/babysitter.png";
import Driver1 from "../images/Driver1.png";
import Cook from "../images/Cook.png";
import patient from "../images/Patientcare1.png";
import cleaning from "../images/cleaning.png";
import allwork from "../images/all work.png";

const Home = () => {
  const navigate = useNavigate();
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const toggleRegisterPopup = () => {
    setIsRegisterOpen(!isRegisterOpen);
  };

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    // Handle registration logic here
    alert("Registration submitted!");
    setIsRegisterOpen(false);
  };

  const jobMembers = [
    {
      image: maids,
      name: "Radhika Kumari",
      work: "All Maids",
      experience: "4 Year",
      age: "35",
    },
    {
      image: Driver1,
      name: "Jaypal Vyas",
      work: "Driver",
      experience: "4 Year",
      age: "60",
    },
    {
      image: babysitter,
      name: "Sunita Gore",
      work: "Baby sitter",
      experience: "5 Year",
      age: "60",
    },
    {
      image: Cook,
      name: "anita tarkhan",
      work: "Cook",
      experience: "3 Year",
      age: "31",
    },
    {
      image: patient,
      name: "Sonam gupta",
      work: "Patient Care",
      experience: "3 Year",
      age: "25",
    },
    {
      image: cleaning,
      name: "Reena bai",
      work: "Cleaning",
      experience: "2 Year",
      age: "35",
    },
    {
      image: allwork,
      name: "Lakshmi shahu",
      work: "All Work",
      experience: "2 Year",
      age: "30",
    },
  ];

  const cityLocations = [
    { image: Ahmedabad, name: "Maid in Ahmedabad" },
    { image: vadodra, name: "Maid in Vadodara" },
    { image: surat, name: "Maid in Surat" },
    { image: rajkot, name: "Maid in Rajkot" },
    { image: vapi, name: "Maid in Vapi" },
    { image: gandhinagar, name: "Maid in Gandhinagar" },
    { image: bhavnagar, name: "Maid in Bhavnagar" },
    { image: jaipur, name: "Maid in Udaipur" },
    { image: mehsana, name: "Maid in Mehsana" },
    { image: mumbai, name: "Maid in Mumbai" },
    { image: bangalore, name: "Maid in Bangalore" },
  ];

  const videoRef = useRef(null);

  useEffect(() => {
    const playVideo = async () => {
      if (videoRef.current) {
        try {
          await videoRef.current.play();
        } catch (error) {
          console.log("Video autoplay failed:", error);
          document.addEventListener(
            "click",
            () => {
              videoRef.current.play();
            },
            { once: true },
          );
        }
      }
    };

    playVideo();
  }, []);

  const handleCall = () => {
    ReactGA.event({
      category: "Contact",
      action: "Clicked Call Button",
      label: "Contact Page",
    });
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    ReactGA.event({
      category: "Contact",
      action: "Clicked WhatsApp Button",
      label: "Contact Page",
    });
    const phoneNumber = `${contactConfig.phone}`;
    const message = "Hello, I would like to know more about your services.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };
  useEffect(() => {
    ReactGA.event({
      category: "Page View",
      action: "Visited Contact Page",
      label: "Contact Page Section",
    });
  }, []);
  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        "service_v4bj4cq",
        "template_a7bino9",
        form.current,
        "EPURM9NpZ87StWlSC",
      );

      alert("✅ Message sent successfully!");
      e.target.reset();
    } catch (error) {
      console.error("FAILED...", error.text);
      alert("❌ Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ------------------- SEO HELMET ------------------- */}
      <Helmet>
        <title>Best Trusted Home Services in Ahmedabad - JP Home Services</title>
        <meta
          name="description"
          content="Book reliable housemaids, cooks, drivers, babysitters & patient care & 24/7 in Ahmedabad with JP Home Services. Verified helpers call +91 9328843812."
        />
        <meta
          name="keywords"
          content="Home Services in Ahmedabad, Maid Services Ahmedabad, Cook Services Ahmedabad, Babysitter Services Ahmedabad, Patient Care Services Gujarat, Home Help Agency Ahmedabad, Domestic Help Gujarat"
        />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link rel="canonical" href="https://jphomeservice.in/" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Best Trusted Home Services in Ahmedabad - JP Home Services"
        />
        <meta
          property="og:description"
          content="Book reliable housemaids, cooks, drivers, babysitters & patient care & 24/7 in Ahmedabad with JP Home Services. Verified helpers call +91 9328843812."
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="JP Home Services" />
        <meta property="og:url" content="https://jphomeservice.in/" />
        <meta
          property="og:image"
          content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta
          name="twitter:title"
          content="Best Trusted Home Services in Ahmedabad - JP Home Services"
        />
        <meta
          name="twitter:description"
          content="Book reliable housemaids, cooks, drivers, babysitters & patient care & 24/7 in Ahmedabad with JP Home Services. Verified helpers call +91 9328843812."
        />
        <meta
          name="twitter:image"
          content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
        />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "JP Home Services",
              "url": "https://jphomeservice.in/",
              "logo": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+919328843812",
                "contactType": "customer service",
                "contactOption": "TollFree",
                "areaServed": "IN",
                "availableLanguage": ["en","Hindi"]
              },
              "sameAs": [
                "https://www.facebook.com/jphomeservice.in/",
                "https://www.instagram.com/jp_home_service/"
              ]
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
              "@context": "https://schema.org/",
              "@type": "WebSite",
              "name": "JP Home Services - Home Maid, Cook, Babysitter, Driver, Senior Citizen Care, Patient Care, Office Boy, Peon and Servant 24 Hours in Ahmedabad",
              "url": "https://jphomeservice.in/",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "{search_term_string}",
                "query-input": "required name=search_term_string"
              }
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "JP Home Services - Home Maid, Cook, Babysitter, Driver, Senior Citizen Care, Patient Care, Office Boy, Peon and Servant 24 Hours in Ahmedabad",
            "image": "https://jphomeservice.in/static/media/aboutus.8b550e39dae1b5add133.png",
            "@id": "https://jphomeservice.in/#localbusiness",
            "url": "https://jphomeservice.in/",
            "telephone": "+919328843812",
            "priceRange": "₹",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Swaminarayan Avenue, A- 316/317, nr. AEC Cross Road, AEC Char Rasta, Naranpura",
              "addressLocality": "Ahmedabad, Gujarat",
              "postalCode": "380013",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 23.0553097,
              "longitude": 72.54661779999999
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
              ],
              "opens": "09:00",
              "closes": "18:00"
            },
            "sameAs": [
              "https://www.facebook.com/jphomeservice.in/",
              "https://www.instagram.com/jp_home_service/"
            ] 
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "@id": "https://jphomeservice.in/#home-services",
            "name": "Home Help Services",
            "serviceType": "Domestic and Home Care Services",
            "description": "JP Home Service provides professional house maid, babysitter, elderly care, patient care, cook, driver, office boy and 24x7 servant services.",
            "url": "https://jphomeservice.in/",
            "areaServed": [
              {
                "@type": "City",
                "name": "Ahmedabad"
              },
              {
                "@type": "City",
                "name": "Surat"
              },
              {
                "@type": "City",
                "name": "Vadodara"
              },
              {
                "@type": "City",
                "name": "Rajkot"
              }
            ],
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "@id": "https://jphomeservice.in/#service-catalog",
              "name": "JP Home Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "@id": "https://jphomeservice.in/#house-maid-service",
                    "name": "House Maid Services",
                    "serviceType": "House Maid Services",
                    "description": "Professional house maid services for household cleaning, cooking, childcare and daily home support.",
                    "url": "https://jphomeservice.in/Best-House-MaidService-In-Ahmedabad"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "@id": "https://jphomeservice.in/#baby-sitting-service",
                    "name": "Baby Sitting",
                    "serviceType": "Baby Sitting Services",
                    "description": "Reliable babysitting services for families who need professional childcare and support.",
                    "url": "https://jphomeservice.in/baby-sitting"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "@id": "https://jphomeservice.in/#elderly-care-service",
                    "name": "Elderly Care",
                    "serviceType": "Elderly Care Services",
                    "description": "Professional elderly care services with assistance and daily support for senior family members.",
                    "url": "https://jphomeservice.in/elderly-care"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "@id": "https://jphomeservice.in/#patient-care-service",
                    "name": "Patient Care",
                    "serviceType": "Patient Care Services",
                    "description": "Patient care services providing daily assistance, personal care and support at home.",
                    "url": "https://jphomeservice.in/patient-care"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "@id": "https://jphomeservice.in/#24x7-servant-service",
                    "name": "24/7 Servant",
                    "serviceType": "24/7 Servant Services",
                    "description": "24/7 servant services for household assistance and everyday home support.",
                    "url": "https://jphomeservice.in/servant"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "@id": "https://jphomeservice.in/#cook-service",
                    "name": "Cook",
                    "serviceType": "Home Cook Services",
                    "description": "Home cook services for daily meal preparation, kitchen support, food hygiene and household cooking needs.",
                    "url": "https://jphomeservice.in/cook"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "@id": "https://jphomeservice.in/#driver-service",
                    "name": "Driver",
                    "serviceType": "Driver Services",
                    "description": "Professional driver services for families and individuals requiring reliable transportation support.",
                    "url": "https://jphomeservice.in/driver"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "@id": "https://jphomeservice.in/#office-boy-service",
                    "name": "Office Boy",
                    "serviceType": "Office Boy Services",
                    "description": "Office boy services for routine office assistance, support work and daily workplace tasks.",
                    "url": "https://jphomeservice.in/office-boy"
                  }
                }
              ]
            }
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Person",
                "@id": "https://jphomeservice.in/#radhika-kumari",
                "name": "Radhika Kumari",
                "url": "https://jphomeservice.in/",
                "image": "https://jphomeservice.in/static/media/maid%20indian.d4e03a469f507759a2ab.jpg",
                "jobTitle": "All Maids",
                "worksFor": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                }
              },
              {
                "@type": "Person",
                "@id": "https://jphomeservice.in/#jaypal-vyas",
                "name": "Jaypal Vyas",
                "url": "https://jphomeservice.in/",
                "image": "https://jphomeservice.in/static/media/Driver1.d00c6faa00f8cb51d0fe.png",
                "jobTitle": "Driver",
                "worksFor": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                }
              },
              {
                "@type": "Person",
                "@id": "https://jphomeservice.in/#sunita-gore",
                "name": "Sunita Gore",
                "url": "https://jphomeservice.in/",
                "jobTitle": "Baby Sitter",
                "worksFor": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                }
              },
              {
                "@type": "Person",
                "@id": "https://jphomeservice.in/#anita-tarkhan",
                "name": "Anita Tarkhan",
                "url": "https://jphomeservice.in/",
                "jobTitle": "Cook",
                "worksFor": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                }
              },
              {
                "@type": "Person",
                "@id": "https://jphomeservice.in/#sonam-gupta",
                "name": "Sonam Gupta",
                "url": "https://jphomeservice.in/",
                "jobTitle": "Patient Care",
                "worksFor": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                }
              },
              {
                "@type": "Person",
                "@id": "https://jphomeservice.in/#reena-bai",
                "name": "Reena Bai",
                "url": "https://jphomeservice.in/",
                "jobTitle": "Cleaning",
                "worksFor": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                }
              },
              {
                "@type": "Person",
                "@id": "https://jphomeservice.in/#lakshmi-shahu",
                "name": "Lakshmi Shahu",
                "url": "https://jphomeservice.in/",
                "jobTitle": "All Work",
                "worksFor": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                }
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <div className="main-content-wrapper">
        <div className="home">
          {/* Register Popup */}
          {isRegisterOpen && (
            <div className="popup-overlay" onClick={toggleRegisterPopup}>
              <div
                className="popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <button className="close-btn" onClick={toggleRegisterPopup}>
                  ×
                </button>

                <div className="form-header">
                  <h1>Book Now</h1>
                  {/* <div className="header-border"></div> */}
                </div>
                <form className="contact-form" ref={form} onSubmit={sendEmail}>
                  {/* <div className="form-group">
                      <label htmlFor="location">Maid in Ahmedabad</label>
                    </div> */}

                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Your Name*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="emailid"
                      placeholder="Email Address*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      id="phone"
                      name="contactno"
                      placeholder="Phone Number*"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <select id="category" required name="ServiceRequired">
                        <option value="">Choose a category</option>
                        <option value="House Maid">House Maid</option>
                        <option value="Baby Sitting">Baby Sitting</option>
                        <option value="Elderly Care">Elderly Care</option>
                        <option value="Patient Care">Patient Care</option>
                        <option value="Cook">Cook</option>
                        <option value="Driver">Driver</option>
                        <option value="Full Time Servant">24x7 Servant</option>
                        <option value="Office Boy">Office Boy</option>
                        <option value="Pet Care">Pet Care</option>
                      </select>
                    </div>
                  </div>

                  {/* <div className="form-group">
                      <textarea
                        id="message"
                        placeholder="Your Message*"
                        rows="5"
                        name="user_message"
                        required
                      ></textarea>
                    </div> */}

                  <button
                    type="submit"
                    className="submit-btn1"
                    disabled={loading}
                    onClick={() => {
                      return window.gtag_report_conversion
                        ? window.gtag_report_conversion(
                          "https://jphomeservice.in/",
                        )
                        : true;
                    }}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </div>
          )}
          {/* Floating Contact Icons */}
          <div className="floating-contact-icons">
            <div
              className="contact-icon whatsapp-icon"
              onClick={handleWhatsApp}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
              </svg>
            </div>
            <div className="contact-icon call-icon" onClick={handleCall}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
                <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
              </svg>
            </div>
          </div>

          {/* Hero Section with Video Background */}
          <section className="hero-section">
            <div className="video-background">
              <video
                ref={videoRef}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
              >
                <source
                  src="https://videos.pexels.com/video-files/9473239/9473239-uhd_1440_2560_24fps.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <div className="video-overlay"></div>
            </div>
            <div className="hero-content">
              <h1>Find Trusted House Help Services</h1>
              <p>Professional maids, cooks, and cleaners for your home</p>
              <div className="hero-buttons">
                <button className="cta-button" onClick={toggleRegisterPopup}>
                  Book Now
                </button>
              </div>
            </div>
          </section>

          {/* Quick Hire Section with 4 cards per row */}
          <section className="main-content quick-hire-section">
            <h2>Employees you Can Hire</h2>
            <div className="service-roles-grid">
              <div className="role-card">
                <div className="role-icon">
                  <img src={homemaid} alt="House Maid" />
                </div>
                <h3>House Maid Services</h3>
                <p className="h5">
                  Managing a household requires care, consistency, and attention
                  to detail — and that's exactly what JP Home Services delivers.
                </p>
                <a
                  href="/Best-House-MaidService-In-Ahmedabad"
                  className="read-more-btn"
                >
                  Read More
                </a>
              </div>
              <div className="role-card">
                <div className="role-icon">
                  <img src={babysitting} alt="Baby Sitting" />
                </div>
                <h3>Baby Sitting</h3>
                <p className="h5">
                  Your child deserves care that feels like family. At J P Home
                  Services, we provide professional babysitter services in
                  Ahmedabad, Surat, Vadodara, Rajkot, and all major cities of
                  Gujarat, ensuring your little ones receive warmth, attention,
                  and protection — even when you're away.
                </p>
                <a href="/baby-sitting" className="read-more-btn">
                  Read More
                </a>
              </div>
              <div className="role-card">
                <div className="role-icon">
                  <img src={ElderlyCare} alt="Elderly Care" />
                </div>
                <h3>Elderly Care</h3>
                <p className="h5">
                  As our parents and grandparents grow older, they deserve
                  comfort, dignity, and companionship — not just care. At JP
                  Home Services, we understand the emotional and physical needs
                  of the elderly.
                </p>
                <a href="/elderly-care" className="read-more-btn">
                  Read More
                </a>
              </div>
              <div className="role-card">
                <div className="role-icon">
                  <img src={patientcare} alt="Baby Sitting" />
                </div>
                <h3>Patient Care</h3>
                <p className="h5">
                  At JP Home Services, we provide professional, trained, and
                  compassionate caregivers and nurses who ensure your family
                  members get personalized patient care right at home — with
                  dignity, comfort, and respect.
                </p>
                <a href="/patient-care" className="read-more-btn">
                  Read More
                </a>
              </div>
              <div className="role-card">
                <div className="role-icon">
                  <img src={service} alt="Full Time Service" />
                </div>
                <h3>24/7 Servant</h3>
                <p className="h5">
                  Managing a home that runs smoothly day and night requires
                  trusted support. At JP Home Services, we understand that some
                  families need 24x7 live-in domestic staff — professionals who
                  can handle household responsibilities with care, dedication,
                  and trust.
                </p>
                <a href="/servant" className="read-more-btn">
                  Read More
                </a>
              </div>
              <div className="role-card">
                <div className="role-icon">
                  <img
                    src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80"
                    alt="Cook"
                  />
                </div>
                <h3>Cook</h3>
                <p className="h5">
                  A dedicated and creative cook with strong knowledge of
                  international cuisines and kitchen management. Focused on
                  maintaining high food quality, hygiene, and customer
                  satisfaction through innovative recipes and attention to
                  detail.
                </p>
                <a href="/cook" className="read-more-btn">
                  Read More
                </a>
              </div>
              <div className="role-card">
                <div className="role-icon">
                  <img src={driver} alt="Driver" />
                </div>
                <h3>Driver</h3>
                <p className="h5">
                  JP Home Service provides safe, reliable, and comfortable
                  driver services for every need — whether it’s daily office
                  travel, airport transfers, business meetings, or outstation
                  trips. All our drivers are well-trained, disciplined, and
                  verified professionals who ensure punctuality, road safety,
                  and complete customer satisfaction.
                </p>
                <a href="/driver" className="read-more-btn">
                  Read More
                </a>
              </div>
              <div className="role-card">
                <div className="role-icon">
                  <img src={officeboy} alt="Office Boy" />
                </div>
                <h3>Office Boy</h3>
                <p className="h5">
                  JP Home Service provides reliable and well-trained office boys
                  to keep your workplace running smoothly. Our staff handle
                  daily office tasks such as serving refreshments, maintaining
                  cleanliness, organizing files, managing deliveries, and
                  assisting office staff with routine duties.
                </p>
                <a href="/office-boy" className="read-more-btn">
                  Read More
                </a>
              </div>
            </div>
          </section>

          {/* Trust Safety Section */}
          <section className="trust-safety-section">
            <div className="container1">
              <div className="trust-content">
                <div className="trust-text">
                  <h2>We're big on trust & safety.</h2>
                  <p className="trust-description">
                    Made go through an extensive vetting process before they are
                    listed on Maid in Ahmedabad.
                  </p>

                  <div className="safety-features">
                    <div className="feature-item1">
                      <div className="feature-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <span>Identity check</span>
                    </div>

                    <div className="feature-item1">
                      <div className="feature-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M14 2V8H20"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M16 13H8"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M16 17H8"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M10 9H9H8"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <span>Document verification</span>
                    </div>

                    <div className="feature-item1">
                      <div className="feature-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <span>In-person interview</span>
                    </div>

                    <div className="feature-item1">
                      <div className="feature-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 6V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <span>Training session</span>
                    </div>
                  </div>
                </div>

                <div className="trust-image">
                  <div className="image-placeholder">
                    <div className="placeholder-content">
                      <div className="shield-icon">
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                            fill="#7a2f7b"
                          />
                          <path
                            d="M12 2L4 5v7c0 6 8 10 8 10s8-4 8-10V5l-8-3z"
                            stroke="#4a154b"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                      <span>Trust & Safety</span>
                      <p>Verified Professionals</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/** googlereview*/}
          <section>
            {/* <!-- Elfsight Google Reviews | Untitled Google Reviews --> */}
            <script src="https://elfsightcdn.com/platform.js" async></script>
            <div
              className="elfsight-app-0e7d82a5-8bcb-4f37-adb4-5a28ed4f6714"
              data-elfsight-app-lazy
            ></div>
          </section>

          {/* Why Choose Us Section */}
          <section className="why-choose-us">
            <div className="container">
              <h2>Why Should You Choose Us?</h2>
              <p className="choose-description">
                Quick response time. Emergency response time is guaranteed to be
                one hour or less, and a live person will answer your call or you
                can order service. So, you can contact us for our services
                without any unnecessary hassle.
              </p>
              <div className="choose-features">
                <div className="choose-item">
                  <span className="count">5+</span>
                  <p>Years of Experience</p>
                </div>
                <div className="choose-item">
                  <span className="count">5000+</span>
                  <p>All India Maids</p>
                </div>
                <div className="choose-item">
                  <span className="count">500+</span>
                  <p>Our Clients</p>
                </div>
                <div className="choose-item">
                  <span className="count">5+</span>
                  <p>Our Branches</p>
                </div>
              </div>
            </div>
          </section>

          {/* Service Roles Section */}
          {/* <section className="main-content service-roles-section">
            <h2>Our Service</h2>
            <p className="section-subtitle">All India Maid Services offer wide range of services as per clients requirements.</p>
            <div className="service-roles detailed">
              <div className="role-card detailed">
                <div className="card-image">
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCslZsrymX_VpEB1E6_BqxrJGrSDmL17nT_g&s" alt="All Work House Maid" />
                </div>
                <h3>All Work House Maid</h3>
                <p>Complete household work including cleaning, cooking, and more</p>
                <a href="/house-maid" className="read-more-btn">Read More</a>
              </div>
              <div className="role-card detailed">
                <div className="card-image">
                  <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80" alt="Cook" />
                </div>
                <h3>Patient Care</h3>
                <p>Expert caregivers for infants and young children</p>
                <a href="/about-us" className="read-more-btn">Read More</a>
              </div>
              <div className="role-card detailed">
                <div className="card-image">
                  <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80" alt="Cook" />
                </div>
                <h3>Cook</h3>
                <p>Expert cooks for daily meals and special occasions</p>
                <a href="/cook" className="read-more-btn">Read More</a>
              </div>
              <div className="role-card detailed">
                <div className="card-image">
                  <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80" alt="Cook" />
                </div>
                <h3>Baby Sitting</h3>
                <p>Expert caregivers for infants and young children</p>
                <a href="/baby-sitting" className="read-more-btn">Read More</a>
              </div>
              <div className="role-card detailed">
                <div className="card-image">
                  <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80" alt="Cook" />
                </div>
                <h3>Elderly Care</h3>
                <p>Expert caregivers for the elderly, ensuring comfort and safety</p>
                <a href="/elderly-care" className="read-more-btn">Read More</a>
              </div>
              <div className="role-card detailed">
                <div className="card-image">
                  <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80" alt="Cook" />
                </div>
                <h3>Driver</h3>
                <p>Expert drivers for safe and reliable transportation</p>
                <a href="/driver" className="read-more-btn">Read More</a>
              </div>
              <div className="role-card detailed">
                <div className="card-image">
                  <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80" alt="Cook" />
                </div>
                <h3>24x7  Servant</h3>
                <p>Expert caregivers available around the clock</p>
                <a href="/about-us" className="read-more-btn">Read More</a>
              </div>
              <div className="role-card detailed">
                <div className="card-image">
                  <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80" alt="Cook" />
                </div>
                <h3>Office Boy</h3>
                <p>Expert caregivers for infants and young children</p>
                <a href="/about-us" className="read-more-btn">Read More</a>
              </div>
            </div>
          </section> */}

          {/* Hire Us Section */}
          <section className="hire-us">
            <div className="container">
              <h2>Why Hire Us?</h2>
              <p className="hire-description">
                Choose us because of our reputation for excellence. For more
                than 10 years, we've earned a name for quality and client
                satisfaction.
              </p>
              <div className="hire-features">
                <div className="feature-item">
                  <span className="icon">✔</span>
                  <span>100% Client Satisfaction Guaranteed</span>
                </div>
                <div className="feature-item">
                  <span className="icon">⏳</span>
                  <span>Flexible, Reliable, Affordable</span>
                </div>
                <div className="feature-item">
                  <span className="icon">↻</span>
                  <span>Free Replacement Within Two Days</span>
                </div>
                <div className="feature-item">
                  <span className="icon">🔍</span>
                  <span>Background-Checked Staff</span>
                </div>
                <div className="feature-item">
                  <span className="icon">📞</span>
                  <span>365 Days Call Support for Clients</span>
                </div>
              </div>
              <div className="welcome-section">
                <div className="welcome-image">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCslZsrymX_VpEB1E6_BqxrJGrSDmL17nT_g&s"
                    alt="Welcome to Maid in Ahmedabad"
                  />
                </div>
                <div className="welcome-text">
                  <h2>Welcome To JP Home Service</h2>
                  <p>
                    Do you need trustworthy housekeeping services but don't know
                    how to find one?
                  </p>
                  <div className="welcome-buttons23">
                    <button
                      className="cta-btn1 secondary23 assistant-btn"
                      onClick={() => {
                        const number = `${contactConfig.phone}`;
                        window.history.pushState({}, "", `/call/${number}`);
                        if (window.gtag) {
                          window.gtag("event", "conversion", {
                            send_to: "AW-16629382441/EFuzCL_s9cIbEKn6wPk9",
                          });
                        }
                        setTimeout(() => {
                          window.location.href = `tel:${number}`;
                        }, 600);
                      }}
                    >
                      Call Now: {contactConfig.phone}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <LatestThreeBlog />

          {/* Job Members Section */}
          <JobMember members={jobMembers} />

          {/* City Locations Section */}
          <CityLocation cities={cityLocations} />
        </div>
      </div>
    </>
  );
};

export default Home;
